import { render, staticRenderFns } from "./getStarRatingPendingListComponent.vue?vue&type=template&id=402a4502&scoped=true&"
import script from "./getStarRatingPendingListComponent.vue?vue&type=script&lang=js&"
export * from "./getStarRatingPendingListComponent.vue?vue&type=script&lang=js&"
import style0 from "./getStarRatingPendingListComponent.vue?vue&type=style&index=0&id=402a4502&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402a4502",
  null
  
)

export default component.exports